<template lang="html">
  <v-text-field
    label="Departure Date/Time"
    icon="mdi-calendar"
    @input="$emit('input', $event)"
    :value="value"
    class="form-control mt-4"
    :name="name"
    ref="datetime"/>
</template>

<script>
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

export default {
  props: {
    name: String,
    value: String,
    minDate: String
  },
  data: () => ({
    _fp: {}
  }),
  computed: {
    config: vm => ({
      enableTime: true,
      altFormat: 'F j, Y h:i K',
      altInput: true,
      dateFormat: 'Y/m/d H:i:S',
      minDate: vm.minDate,
    })
  },
  mounted () {
    this._fp = flatpickr(this.$refs.datetime.$refs.input, this.config)
  },
  watch: {
    minDate (val) {
      this._fp.set('minDate', val)
    }
  },
  methods: {
  }
}
</script>

<style lang="css" scoped>
</style>
